import { useState } from "react";
import {
  FunctionalInstance,
  WidgetInstanceListItem,
  WidgetInstanceSet,
} from "../../../../types/widget-instance";
import useGetWidgetInstancesByRole from "../../../../queryHooks/widgetInstanceQueryHooks/useGetWidgetInstancesByRole";
import { ListGroup } from "react-bootstrap";
import "./widgetSet.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import { Loader, Search } from "@trcsolutions/springboard-ui";
import iconMap from "./iconMap";
import { useAppSelector } from "app/hooks";
import { selectIsNavbar } from "selectors/layoutSelectors";

const prepareWidgetSet = (
  functionalities: Array<FunctionalInstance> = []
): WidgetInstanceSet => {
  const widgetSet: WidgetInstanceSet = {} as WidgetInstanceSet;
  functionalities.forEach((item) => {
    if (widgetSet[item.group_name]) {
      widgetSet[item.group_name] = [
        ...widgetSet[item.group_name],
        {
          widgetId: item.functionality_id,
          widgetName: item.functionality_name,
          widgetIcon: item.instance_icon,
          widgetPath: item.register_path,
          isRegistered: item.isregister,
          widgetSecondaryName: item.secondary_name,
          widgetInstanceId: item.id,
          widgetInstanceName: item.functionality_name,
          widgetInstanceLabel: item.secondary_name,
          isDefault: item.is_default,
        },
      ];
    } else {
      widgetSet[item.group_name] = [
        {
          widgetId: item.functionality_id,
          widgetName: item.functionality_name,
          widgetIcon: item.instance_icon,
          widgetPath: item.register_path,
          isRegistered: item.isregister,
          widgetSecondaryName: item.secondary_name,
          widgetInstanceId: item.id,
          widgetInstanceName: item.functionality_name,
          widgetInstanceLabel: item.secondary_name,
          isDefault: item.is_default,
        },
      ];
    }
  });
  return widgetSet;
};

const WidgetSetList = () => {
  const roleId = localStorage.getItem("role_id");
  const { data, isLoading } = useGetWidgetInstancesByRole<WidgetInstanceSet>({
    select: (res) => prepareWidgetSet(res.funcsFuncgroups),
    roleId,
  });
  const widgetInstanceSet = data ?? ({} as WidgetInstanceSet);
  const [searchKey, setSearchKey] = useState("");
  const isNavbar = useAppSelector(selectIsNavbar);

  const handleSearch = (value: string) => {
    setSearchKey(value);
  };

  const filterWidgetInstances = (widgetInstance: WidgetInstanceListItem) =>
    widgetInstance.widgetInstanceLabel
      .toLowerCase()
      .includes(searchKey.toLowerCase());

  function renderNavItem(widgetInstance: WidgetInstanceListItem) {

    return (
      <div className={`sub-item ${!(isNavbar || !widgetInstance.widgetIcon) ? "si-icon" : ""}`}>
        {widgetInstance.widgetIcon && (
          <FontAwesomeIcon
            icon={iconMap[widgetInstance.widgetIcon as keyof typeof iconMap]}
            className="inst-icon text-white me-2"
            title={widgetInstance.widgetInstanceLabel}
            size={isNavbar ? "lg" : "2x"}
          ></FontAwesomeIcon>
        )}
        {(isNavbar || !widgetInstance.widgetIcon) && widgetInstance.widgetInstanceLabel}
        {widgetInstance.isDefault && (
          <FontAwesomeIcon
            icon={faStar}
            className="def-wid-icon text-white me-2"
            title="Default Widget"
            size="sm"
          ></FontAwesomeIcon>
        )}
      </div>
    )
  }

  return (
    <>
      {/* <Search searchValue={searchKey} handleSearch={handleSearch} /> */}
      <div className="widgets-wrapper">
        {isLoading && <Loader />}
        <ListGroup as="ul">
          {Object.keys(widgetInstanceSet).map((set, i) => {
            return (
              <ListGroup.Item as="li" active className="p-0" key={i}>
                <ListGroup className="widgets-layer">
                  {widgetInstanceSet[set].filter(filterWidgetInstances)
                    .length === 0 ? (
                    <small className="font-italic text-center font-weight-light pe-none">
                      No widgets found
                    </small>
                  ) : (
                    widgetInstanceSet[set]
                      .filter(filterWidgetInstances)
                      .map((widgetInstance) => {
                        return (
                          <ListGroup.Item
                            as={NavLink}
                            to={`/widget-dashboard/${widgetInstance.widgetInstanceId}`}
                            className="child"
                            key={widgetInstance.widgetInstanceId}
                          >
                            {renderNavItem(widgetInstance)}
                          </ListGroup.Item>
                        );
                      })
                  )}
                </ListGroup>
              </ListGroup.Item>
            );
          })}
        </ListGroup>
      </div>
    </>
  );
};

export default WidgetSetList;
